import React, { Component } from 'react';
import Radium from 'radium';


class Checkbox extends Component {

	renderTick() {
		if (!this.props.on) {
			return null;
		}

		return (	
			<svg width="13px" height="11px" viewBox="0 0 13 11" version="1.1">
				<g id="Landing" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Landing-Light" transform="translate(-261.000000, -421.000000)">
						<g id="Group-4" transform="translate(261.000000, 421.000000)" fill={this.props.style.colors.black}>
							<path d="M12.0157101,0.322380131 C12.5004087,0.774368883 12.5269252,1.53370401 12.0749365,2.0184026 L4.98215354,9.6244811 L4.97601845,9.63224556 C4.94572432,9.67112365 4.91270326,9.70856594 4.87695526,9.74431394 C4.40832611,10.2129431 3.64852814,10.2129431 3.17989899,9.74431394 L0.351471863,6.91588681 C-0.117157288,6.44725766 -0.117157288,5.68745969 0.351471863,5.21883054 C0.820101013,4.75020139 1.57989899,4.75020139 2.04852814,5.21883054 L3.993,7.164 L10.3196876,0.381606541 C10.7716764,-0.103092055 11.5310115,-0.129608622 12.0157101,0.322380131 Z" id="Combined-Shape"></path>
						</g>
						<rect id="Rectangle" stroke={this.props.style.colors.black} strokeWidth="5" x="253.5" y="413.5" width="26" height="26" rx="10"></rect>
					</g>
				</g>
			</svg>
		);
	}

	render() {
		return (
			<div style={this.localStyles().container} onClick={() => this.props.onToggle(!this.props.on)}>
				{this.renderTick()}
			</div>
		);
	}

	localStyles() {
		return {
			container: {
				cursor: "pointer",
				userSelect: "none",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				width: 20,
				height: 20,
				borderWidth: 3,
				borderStyle: "solid",
				borderRadius: 8,
				marginRight: 10,
				borderColor: this.props.style.colors.black
			}
		}
	}
}

export default Radium(Checkbox);


// WEBPACK FOOTER //
// ./src/components/Checkbox.js